import React, { useMemo, useContext, useState } from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';
import { AppContext, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';
import { useTranslation } from 'react-i18next';

const Default = () => {
    const { t } = useTranslation();
    //const { addFilter } = useSettingsContext(dataProviderName);

    const [filters, setFilters] = useState()


    const { userCapabilities } = useContext(AppContext);

    const now = new Date();
    const startPreviousYear = (now.getFullYear() - 1) + '-01-01';
    const startYear = now.getFullYear() + '-01-01';
    const startPreviousMonth = now.getFullYear() + '-' + String(now.getMonth()).padStart(2, '0') + '-01';
    const startMonth = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-01';

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">

            <KPI
                title="Total Installed"
                icon="faCar"
                className="superuserData"
                dataProviderName={'renters/installed/statistic/total'}
                // filterbutton={{
                //     visible: true,
                //     label: t("View"),
                //     callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                // }}
                // filters={{
                //     items: [{

                //     }]
                // }}
            />

            <KPI
                title={t("To be checked")}
                icon="faExclamationTriangle"
                dataProviderName={'renters/installed/statistic/checked'}
                // filterbutton={{
                //     visible: true,
                //     label: t("View"),
                //     callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                // }}
                // filters={{
                //     items: [{

                //     }]
                // }}
            />
            <KPI
                title={t("Importable")}
                icon="faArrowUp"
                dataProviderName={'renters/installed/statistic/importable'}
                // filterbutton={{
                //     visible: true,
                //     label: t("View"),
                //     callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                // }}
                // filters={{
                //     items: [{
                //         field: "actions",
                //         operator: "equals",
                //         value: "create"
                //     }]
                // }}
            />
            <KPI
                title={t("Synched")}
                icon="faCheck"
                dataProviderName={'renters/installed/statistic/synced'}

            />


        </Box>
        <List />

    </>, [])

}

export default Default;


